module.exports = "toaster-container .brs-message {\n  /*top: 25vh !important;\r\n        right: 25vw !important;\r\n        width: 50vw !important;*/ }\n\ntoaster-container .toast-top-full-width {\n  /*top: 25vh !important;\r\n        right: 25vw !important;\r\n        width: 50vw !important;*/ }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/application/containers/application/application.component.scss
// module id = ./src/app/application/containers/application/application.component.scss
// module chunks = main